import { render, staticRenderFns } from "./CostConsultation.vue?vue&type=template&id=60fe91f1&scoped=true&"
import script from "./CostConsultation.vue?vue&type=script&lang=js&"
export * from "./CostConsultation.vue?vue&type=script&lang=js&"
import style0 from "./CostConsultation.vue?vue&type=style&index=0&id=60fe91f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fe91f1",
  null
  
)

export default component.exports